const reviewSliderEl = document.querySelector(".reviewSlider");
if (reviewSliderEl) {
  const swiper = new Swiper(reviewSliderEl, {
    slidesPerView: 3,
    spaceBetween: 30,
    loop: true,

    navigation: {
      nextEl: reviewSliderEl.querySelector(".swiper-button-next"),
      prevEl: reviewSliderEl.querySelector(".swiper-button-prev"),
    },

    breakpoints: {
      0: {
        slidesPerView: 1
      },
      768: {
        slidesPerView: 2
      },
      1024: {
        slidesPerView: 3
      }
    }
  });
}


const mySwiperEl = document.querySelector(".mySwiper");
if (mySwiperEl) {
  const swiper1 = new Swiper(mySwiperEl, {
    loop: true,

    autoplay: {
      delay: 4000,
      disableOnInteraction: false,
    },

    navigation: {
      nextEl: mySwiperEl.querySelector(".swiper-button-next"),
      prevEl: mySwiperEl.querySelector(".swiper-button-prev"),
    },

    speed: 800,
  });
}

window.addEventListener('DOMContentLoaded', function () {
  const toggle = document.getElementById('menuToggle');
  const nav = document.getElementById('nav');
  const overlay = document.getElementById('navOverlay');

  function closeMenu() {
    nav.classList.remove('active');
    toggle.classList.remove('active');
    overlay.classList.remove('active');
  }

  if (toggle && nav && overlay) {
    toggle.addEventListener('click', function () {
      nav.classList.toggle('active');
      toggle.classList.toggle('active');
      overlay.classList.toggle('active');
    });

    overlay.addEventListener('click', closeMenu);

    document.querySelectorAll('.nav a').forEach(link => {
      link.addEventListener('click', closeMenu);
    });
  }
});


